export const GET_PLAN_EDITOR_ORDERS_SUCCESS = 'GET_PLAN_EDITOR_ORDERS_SUCCESS';
export const GRAB_PLAN_ORDER_SUCCESS = 'GRAB_PLAN_ORDER_SUCCESS';
export const EDIT_PLAN_EDITOR_ORDER_SUCCESS = 'EDIT_PLAN_EDITOR_ORDER_SUCCESS';
export const GET_PLAN_EDITOR_COMPARE_DATA_SUCCESS = 'GET_PLAN_EDITOR_COMPARE_DATA_SUCCESS';
export const ADD_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS =
    'ADD_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS';
export const ADD_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS =
    'ADD_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS';
export const ADD_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS =
    'ADD_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS';
export const DELETE_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS =
    'DELETE_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS';
export const DELETE_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS =
    'DELETE_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS';
export const DELETE_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS =
    'DELETE_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS';

export const ADD_PLAN_ORDER_STOREY_2D_FILE_SUCCESS = 'ADD_PLAN_ORDER_STOREY_2D_FILE_SUCCESS';
export const ADD_PLAN_ORDER_STOREY_3D_FILE_SUCCESS = 'ADD_PLAN_ORDER_STOREY_3D_FILE_SUCCESS';

export const APPROVE_PLAN_ORDER_SUCCESS = 'APPROVE_PLAN_ORDER_SUCCESS';
export const GENERATE_FILES_PLAN_ORDER_SUCCESS = 'GENERATE_FILES_PLAN_ORDER_SUCCESS';
export const DOWNLOAD_FILES_PLAN_ORDER_SUCCESS = 'DOWNLOAD_FILES_PLAN_ORDER_SUCCESS';
export const EDITOR_EDIT_PLAN_ANNOTATION_SUCCESS = 'EDITOR_EDIT_PLAN_ANNOTATION_SUCCESS';

export const PLAN_EDITOR_UPDATE_PLAN_EDITOR_SUCCESS = 'PLAN_EDITOR_UPDATE_PLAN_EDITOR_SUCCESS';
export const RESET_PLAN_EDITOR_ORDERS_LIST = 'RESET_PLAN_EDITOR_ORDERS_LIST';

export const ADD_PLAN_EDITOR_STOREY_SUCCESS = 'ADD_PLAN_EDITOR_STOREY_SUCCESS';

export const UPDATE_EDITOR_PLAN_ORDER_STOREY_SORT_SUCCESS =
    'UPDATE_EDITOR_PLAN_ORDER_STOREY_SORT_SUCCESS';
export const DELETE_EDITOR_STOREY_SUCCESS = 'DELETE_EDITOR_STOREY_SUCCESS';
export const UPDATE_EDITOR_PLAN_ORDER_SUCCESS = 'UPDATE_EDITOR_PLAN_ORDER_SUCCESS';

export const EDITOR_DELETE_DELIVERY_FILE_SUCCESS = 'EDITOR_DELETE_DELIVERY_FILE_SUCCESS';
